var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80913 6.99941L11.9107 2.11035C11.9794 2.0291 11.9216 1.90566 11.8154 1.90566H10.5685C10.4951 1.90566 10.4248 1.93847 10.3763 1.99472L6.99351 6.02754L3.6107 1.99472C3.56382 1.93847 3.49351 1.90566 3.41851 1.90566H2.17163C2.06538 1.90566 2.00757 2.0291 2.07632 2.11035L6.17788 6.99941L2.07632 11.8885C2.06092 11.9066 2.05104 11.9287 2.04785 11.9523C2.04467 11.9759 2.04831 11.9998 2.05834 12.0214C2.06838 12.0429 2.08439 12.0612 2.10447 12.0739C2.12455 12.0866 2.14786 12.0933 2.17163 12.0932H3.41851C3.49195 12.0932 3.56226 12.0604 3.6107 12.0041L6.99351 7.97129L10.3763 12.0041C10.4232 12.0604 10.4935 12.0932 10.5685 12.0932H11.8154C11.9216 12.0932 11.9794 11.9697 11.9107 11.8885L7.80913 6.99941Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.9ae9e83a0f02e221663b38238052fe66.svg";
export { ForwardRef as ReactComponent };